
import {Component, Prop, Vue} from 'vue-property-decorator';
import {logLevel, stepStatus, TerminalLog, TerminalVariable, WsStepDataMessage} from "@/models/terminal.model";
import {COVERAGE_NORUN} from "@/configs/colors";

@Component
export default class RunReporting extends Vue {
  // Les props
  @Prop() private pos!: number
  @Prop({default: null}) private wstep!: WsStepDataMessage | null
  @Prop() private variables!: TerminalVariable[]
  @Prop({default: false}) private edit!: boolean

  // Les propriétés

  // Les propriétés calculées
  private get stepColorStatus() {
    const status = this.wstep && this.wstep.logs ? this.wstep.logs.status : -1
    const colors = new Map([
      [-1, COVERAGE_NORUN],
      [stepStatus.cancel, 'warning'],
      [stepStatus.pass, 'success'],
      [stepStatus.fail, 'error']
    ])
    return colors.get(status as number)
  }

  private get stepStatusText() {
    if (this.wstep && this.wstep.logs) {
      return ['Canceled', 'Passed', 'Failed'][this.wstep.logs.status as number]
    } else {
      return 'Not executed'
    }
  }

  // Les hooks
  // Les méthodes surveillées
  // Les méthodes d'instance
  // Les méthodes statiques
  private messageColor = (msg: TerminalLog) => {
    const colors = new Map([
      [logLevel.info, 'primary'],
      [logLevel.warning, 'warning'],
      [logLevel.error, 'error']
    ])
    return colors.get(msg.level)
  }
}
